import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { EmailCampaignsTable } from '../components/EmailCampaignsTable';
import { EmailPreviewModal } from '../components/EmailPreviewModal';

export default function EmailCampaignsApproval() {
  const navigate = useNavigate();
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const handlePreview = (campaign) => {
    setSelectedCampaign(campaign);
    setPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setSelectedCampaign(null);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <Button
                onClick={() => navigate('/email-campaigns')}
                variant="ghost"
                size="sm"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
              <Mail className="h-8 w-8 text-indigo-600" />
              Gestión de Campañas
            </h1>
            <p className="text-gray-600 mt-2">
              Visualiza, aprueba y envía tus campañas de email
            </p>
          </div>
        </div>
      </div>

      {/* Información */}
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <Mail className="h-5 w-5 text-blue-600" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              Sistema de Aprobación de Campañas
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <ul className="list-disc list-inside space-y-1">
                <li><strong>Previsualizar:</strong> Ver cómo se verá el email con datos de ejemplo</li>
                <li><strong>Aprobar:</strong> Cambiar estado de "Pendiente" a "Aprobada"</li>
                <li><strong>Enviar Ahora:</strong> Encolar campaña para envío inmediato</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla de Campañas */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Campañas de Email
        </h2>
        <EmailCampaignsTable onPreview={handlePreview} />
      </div>

      {/* Modal de Preview */}
      <EmailPreviewModal
        campaign={selectedCampaign}
        isOpen={previewOpen}
        onClose={handleClosePreview}
      />
    </div>
  );
}
